/* eslint-disable no-nested-ternary */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BillingTooltip } from 'components/Tooltip';
import { ReactComponent as InfoIcon } from 'assets/images/home/infoIcon.svg';
import { Modal, MultiSelectDropdown } from '@heronhr/trivia-games';
import styles from './styles.module.scss';

const StandardProOverviewSection = (props) => {
  const {
    plan,
    term,
    channelBasedBilling,
    handleClick,
    isModalOpen,
    uniqueUsersCount,
    usersCount,
    channels,
    selectedChannels,
    hasChanges,
    setSelectedChannels,
    dropDownChannelOptions,
    handleClickInChannelDropdown,
    handleButtonClick
  } = props;

  const [originalSelectedChannels, setOriginalSelectedChannels] = useState(selectedChannels);
  const [prevUsersCount, setPrevUsersCount] = useState(uniqueUsersCount);
  useEffect(() => {
    if (isModalOpen) {
      setOriginalSelectedChannels(selectedChannels);
    }
  }, [isModalOpen, selectedChannels]);

  useEffect(() => {
    setPrevUsersCount(usersCount);
  }, [usersCount]);

  return (
    <>
      <div className={styles.overviewHeading}>Overview</div>
      <div
        className={`${styles.commonOverview} ${
          channelBasedBilling ? styles.overviewStandardnewWrapper : styles.overviewStandardWrapper
        }`}
      >
        <div className={styles.overviewPlan}>
          {plan}(<span className={styles.basicMontlyStyles}>{term}ly</span>)
          <div className={styles.currentPlan}>current plan</div>
        </div>
        {channelBasedBilling && (
          <div>
            {channels.slice(0, 2).map((channel, index) => (
              <span key={channel.id} className={styles.channel}>
                {channel.label}
                {index === 0 ? ', ' : channels.length > 2 && ' and '}
              </span>
            ))}
            {channels.length > 2 && (
              <span className={styles.channel}>{channels.length - 2} more</span>
            )}{' '}
            <span>
              <BillingTooltip title='Trivia enabled channels , only unique users in these channels will be billed'>
                <InfoIcon />
              </BillingTooltip>
            </span>
            <div className={styles.currentPlan}>
              Channels Enabled{' '}
              <span onClick={handleClick} className={styles.manageChannels}>
                Manage Channels
              </span>
            </div>
          </div>
        )}
        <div>
          {!channelBasedBilling ? usersCount : uniqueUsersCount}{' '}
          <span>
            <BillingTooltip
              title={`${
                channelBasedBilling
                  ? 'Only unique users will be billed and allowed to play'
                  : 'Any user who plays a Game or uses other Trivia features is called Trivia Users.'
              }`}
            >
              <InfoIcon />
            </BillingTooltip>
          </span>
          <div className={styles.currentPlan}>
            {!channelBasedBilling ? 'Active users' : 'unique users'}
          </div>
        </div>
      </div>
      {isModalOpen && (
        <Modal
          open={isModalOpen}
          onCancel={() => {
            handleClick();
            setSelectedChannels(originalSelectedChannels);
          }}
          onConfirm={() => handleButtonClick(plan.toUpperCase())}
          title='Manage channels'
          cancelText='Go Back'
          confirmText='Update'
        >
          <div className={styles.manageChannelsModal}>
            <div className={styles.txt}>CHANNELS TO ENABLE</div>
            <MultiSelectDropdown
              placeholder='search or choose channels'
              value={selectedChannels}
              data={dropDownChannelOptions}
              onChange={handleClickInChannelDropdown}
            />
            <div className={styles.note}>
              Note: Only unique users from the above selected channels will be billed and allowed to
              play Trivia
            </div>
            <div className={styles.modalUniqueUsers}>
              👥 Total Unique users- <span>{uniqueUsersCount}</span>
            </div>
            {hasChanges && (
              <div className={styles.attentionMessage}>
                Attention: You have added a new channel and your Total unique user list has been
                {uniqueUsersCount - prevUsersCount - 1 > 0 ? ' increased' : ' decreased'} by{' '}
                <span>{Math.abs(uniqueUsersCount - prevUsersCount - 1)} users</span>. Your next
                billing will reflect these changes once you update.
              </div>
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

StandardProOverviewSection.propTypes = {
  plan: PropTypes.string.isRequired,
  channelBasedBilling: PropTypes.bool.isRequired,
  term: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  uniqueUsersCount: PropTypes.number.isRequired,
  usersCount: PropTypes.number.isRequired,
  channels: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedChannels: PropTypes.arrayOf(PropTypes.string).isRequired,
  hasChanges: PropTypes.bool.isRequired,
  setSelectedChannels: PropTypes.func.isRequired,
  dropDownChannelOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  handleClickInChannelDropdown: PropTypes.func.isRequired,
  handleButtonClick: PropTypes.func.isRequired
};

export default StandardProOverviewSection;
